import React, { useEffect, useState } from "react";
import BookingsApi from "../state/bookings-api";
import { configStore } from "../state/CommonState";
import { loader } from "../util/loader";
import { containerStatusList } from "../StaticData";

const ContainerListPopup = ({ onClose, onEdit }) => {
  const [selectedContainerStatus, setSelectedContainerStatus] = useState("Planned");
  const [containerList, setContainerList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const fetchContainersByStatus = (containerStatus, page = 1) => {
    loader.show();

    BookingsApi.getContainers(containerStatus, page, 'all', (details) => {
      try {
        const data = details?.data || [];
        const total = details?.total || 0;
        setContainerList(data);
        setTotalPages(Math.ceil(total / 10));
      } catch (err) {
        console.error('Processing error:', err);
        configStore.setModalMessage("Failed to process containers");
      } finally {
        loader.hide();
      }
    });
  };


  useEffect(() => {
    fetchContainersByStatus(selectedContainerStatus, currentPage);
  }, [selectedContainerStatus, currentPage]);

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
      justifyContent: "center", alignItems: "center", zIndex: 1000
    }}>
      <div style={{
        backgroundColor: "#fff", padding: 24, borderRadius: 8,
        width: "1200px", maxHeight: "90vh", overflowY: "auto"
      }}>
        <h2 style={{ fontSize: 20, fontWeight: "bold" }}>All Containers - {selectedContainerStatus}</h2>

        <div style={{ display: "flex", gap: 10, margin: "12px 0" }}>
          {containerStatusList.map(status => (
            <button
              style={{
                color: status === selectedContainerStatus ? "#fff" : "#000",
                backgroundColor: status === selectedContainerStatus && process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
              }}
              key={status}
              className={`button is-light`}
              onClick={() => {
                setSelectedContainerStatus(status);
                setCurrentPage(1);
              }}
            >
              {status}
            </button>
          ))}
        </div>

        <table className="table is-bordered is-fullwidth">
          <thead>
            <tr>
              <th>Container Code</th>
              <th>POL</th>
              <th>FPOD</th>
              <th>Container Number</th>
              <th>Container Type</th>
              <th>Status</th>
              <th>Stuffing Cut-off</th>
              <th>Volume Occupied</th>
              <th>Utilised Weight</th>
              <th>Total Packages</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {containerList.map(c => (
              <tr key={c._id}>
                <td>{c._id}</td>
                <td>{c.pol}</td>
                <td>{c.fpod}</td>
                <td>{c.pol_container_number}</td>
                <td>{c.containerType}</td>
                <td>{c.containerStatus}</td>
                <td>{c.stuffing_cutoff ? new Date(c.stuffing_cutoff).toLocaleString() : 'N/A'}</td>
                <td>{(c.totalVolume || 0)?.toFixed(2)}</td>
                <td>{(c.totalWeight || 0)?.toFixed(2)}</td>
                <td>{c.totalPackages || 0}</td>
                <td>
                  <button className="button is-small is-info" onClick={() => onEdit(c)}>Edit/View</button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12 }}>
          <button className="button is-danger" onClick={onClose}>Close</button>

          <div>
            <button className="button is-small" disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}>
              Previous
            </button>
            <span style={{ margin: "0 10px" }}>{currentPage} / {totalPages}</span>
            <button className="button is-small" disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContainerListPopup;
